class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    if (!this.input) return;

    const allSearchForms = Array.from(this.allSearchInputs)
      .map((input) => input.form)
      .filter(Boolean);

    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onFormReset(event) {
    if (!this.input) return;

    if (event.target !== this.input.form) {
      this.input.value = '';
      this.toggleResetButton();
      this.hideIdleSuggestions();
      this.closest('predictive-search')?.hideIdleSuggestions();
      this.closest('predictive-search')?.close?.(false);
      return;
    }

    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event?.target;
    if (!target) return;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    super.onInputFocus();
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input === target) return;
      input.value = value;
      const host = input.closest('search-form, predictive-search, main-search');
      host?.toggleResetButton?.();
      if (!value.trim()) host?.hideIdleSuggestions?.();
    });
  }
}

if (!customElements.get('main-search')) {
  customElements.define('main-search', MainSearch);
}
